import * as React from "react";
import crxLogo from "../../assets/images/crx.png";
import "./authLayout.scss";
import { useThemePreference } from "../useThemePreference";


type authLayoutProps = {
  children: any;
};

const AuthLayout = ({ children }: authLayoutProps) => {
  // Login and 2FA follow the user's light / dark choice like the rest of the app.
  useThemePreference();
  return (
    <section className={`text-center backgroundImage`}>
      <div
        className={`px-4 py-5 px-md-5 text-center text-lg-start` }
       
      >
        <div className="container text-center ">
          <div className="row gx-lg-5 text-center ">
            <div>
              <div className="logo-container">
                <img src={crxLogo} alt="Crownox logo" width={80} height={100} />
              </div>

              <div className="title-container">
                <span className="header-name">INTERNAL MANAGEMENT SYSTEM</span>
              </div>
              <div className="card mainWrapper">
                <div className="card-body py-5 px-md-5">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="footer">
        <div className="social-links">
          <ul>
            <li>
              <a target="_blank" href="https://twitter.com/Crownox">
                <i className="bi bi-twitter"></i>
              </a>
            </li>
            <li>
              <a target="_blank" href="https://twitter.com/Crownox">
                <i className="bi bi-facebook"></i>
              </a>
            </li>
            <li>
              <a target="_blank" href="https://twitter.com/Crownox">
                <i className="bi bi-linkedin"></i>
              </a>
            </li>
            <li>
              <a target="_blank" href="https://twitter.com/Crownox">
                <i className="bi bi-instagram"></i>
              </a>
            </li>
          </ul>
        </div>
        <div className="copy-rights-container">
          © 2024 Crownox. All rights reserved. contact@crownox.com
        </div>
      </div> */}
    </section>
  );
};

export default AuthLayout;
